








































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import AccountFormRecordType from '@/modules/Account/components/forms/AccountFormRecordType.vue'
import AccountFormContact from '@/modules/Account/components/forms/AccountFormContact.vue'
import AccountFormInfo from '@/modules/Account/components/forms/AccountFormInfo.vue'
import AccountFormSource from '@/modules/Account/components/forms/AccountFormSource.vue'
import AccountFormBusiness from '@/modules/Account/components/forms/AccountFormBusiness.vue'
import AccountFormEmployee from '@/modules/Account/components/forms/AccountFormEmployee.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { newAccount, editAccount } from '@/modules/Account/gql/account.gql'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact, Salutation } from '@/modules/Contact/interfaces/contact'
import { IAccountRecordTypeInput, IAccountInfoInput, IAccountSourceInput, IAccountAdditionalInfoInput, IAccountContactInput } from '@/modules/Account/interfaces/account-form'
import delNonNumCode from '@/utils/delNonNumCode'
import { states } from '@/utils/us_states'
import { salutationKeys } from '@/modules/Contact/helpers/contact'

@Component({
  components: {
    AccountFormRecordType,
    AccountFormContact,
    AccountFormInfo,
    AppDialog,
    AccountFormSource,
    AccountFormBusiness,
    AccountFormEmployee,
    AppSteps
  }
})
export default class AccountForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Account }) readonly account!: Account
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact
  @Prop(String) readonly accountName!: string

  salutationKeys = salutationKeys
  showDialog = false

  loading = false

  recordTypeIndex = 0
  stepIndex = 0

  recordTypeInput: IAccountRecordTypeInput = {
    recordType: { }
  }

  infoInput: IAccountInfoInput = {
    name: '',
    birthday: '',
    parentAccount: {},
    firstName: '',
    middleName: '',
    lastName: '',
    salutationIndex: -1,
    notes: ''
  }

  contactInfoInput: IAccountContactInput = {
    primaryContact: {},
    phone: '',
    billingAddressCountry: '',
    billingAddressStateIdx: -1,
    billingAddressCity: '',
    billingAddressStreet: '',
    billingAddressPostalCode: '',
    otherPhone: '',
    mailingAddressCountry: '',
    mailingAddressStateIdx: -1,
    mailingAddressCity: '',
    mailingAddressStreet: '',
    mailingAddressPostalCode: ''
  }

  sourceInput: IAccountSourceInput = {
    source: {},
    book: {},
    csr: {}
  }

  additionalInfoInput: IAccountAdditionalInfoInput = {}

  get ifBusiness () {
    return this.recordTypeIndex === 0
  }

  get steps () {
    return this.ifBusiness
      ? [
        ['Record Type', 770, 301],
        ['Account Info', 770, 471],
        ['Contact Info', 770, 751],
        ['Business Info', 770, 631],
        ['Employees Info', 770, 481],
        ['Source Info', 770, 361]
      ]
      : [
        ['Record Type', 770, 301],
        ['Account Info', 770, 471],
        ['Contact Info', 770, 751],
        ['Source Info', 770, 361]
      ]
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return this.recordTypeInput.recordType.name ? ' (' + this.recordTypeInput.recordType.name + ')' : ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.account
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.account ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex > 0 && this.stepIndex < this.steps.length - 1
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.account) {
      const {
        name, notes, phone, otherPhone,
        countryCode, otherCountryCode, extensionNumber, otherExtensionNumber,
        countryCallingCode, otherCountryCallingCode,
        billingAddressCountry, billingAddressState, billingAddressCity, billingAddressStreet, billingAddressPostalCode, mailingAddressCountry, mailingAddressState, mailingAddressCity, mailingAddressStreet, mailingAddressPostalCode,
        parentAccount, primaryContact, recordType, csr, book, source, additionalInfoStr, birthday,
        salutation, firstName, middleName, lastName
      } = this.account
      const salutationIndex = this.salutationKeys.findIndex((item) => {
        return item === salutation
      })
      this.recordTypeInput.recordType = {
        id: +recordType.id,
        name: recordType.name
      }
      this.infoInput = {
        name,
        birthday,
        parentAccount: {
          id: parentAccount ? +parentAccount.id : undefined,
          name: parentAccount ? parentAccount.name : ''
        },
        notes,
        salutationIndex,
        firstName,
        middleName,
        lastName
      }
      this.contactInfoInput = {
        primaryContact: {
          id: primaryContact ? +primaryContact.id : undefined,
          name: primaryContact ? primaryContact.name : ''
        },
        phone: (countryCode || '') + ',' + (phone || '') + ',' + (extensionNumber || '') + ',' + (countryCallingCode || ''),
        billingAddressCountry,
        billingAddressStateIdx: states.findIndex(state => state === billingAddressState),
        billingAddressCity,
        billingAddressStreet,
        billingAddressPostalCode,
        otherPhone: (otherCountryCode || '') + ',' + (otherPhone || '') + ',' + (otherExtensionNumber || '') + ',' + (otherCountryCallingCode || ''),
        mailingAddressCountry,
        mailingAddressStateIdx: states.findIndex(state => state === mailingAddressState),
        mailingAddressCity,
        mailingAddressStreet,
        mailingAddressPostalCode
      }

      this.sourceInput = {
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        },
        book: {
          id: book ? +book.id : undefined,
          name: book ? book.name : ''
        },
        csr: {
          id: csr ? +csr.id : undefined,
          name: csr ? csr.username : ''
        }
      }
      const additionalInfo = JSON.parse(additionalInfoStr)
      this.additionalInfoInput = { ...additionalInfo }
    } else if (this.accountName) {
      this.infoInput.name = this.accountName
    } else {
      this.clearForm()
    }

    if (this.contact) {
      this.contactInfoInput = {
        ...this.contactInfoInput,
        primaryContact: {
          id: +this.contact.id
        }
      }
    }
  }

  handleStepClick (index: number) {
    if (!this.account) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  onRecordTypeChanged (index: number) {
    this.recordTypeIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.account) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    } else {
      this.showDialog = false
    }
  }

  async handleCreate () {
    const {
      recordTypeInput: { recordType: {
        id: recordTypeId
      } },
      infoInput: {
        name, notes,
        birthday,
        salutationIndex,
        firstName,
        middleName,
        lastName,
        parentAccount: {
          id: parentAccountId
        }
      },
      contactInfoInput: {
        primaryContact: {
          id: primaryContactId
        },
        phone,
        billingAddressCountry,
        billingAddressStateIdx,
        billingAddressCity,
        billingAddressStreet,
        billingAddressPostalCode,
        otherPhone,
        mailingAddressCountry,
        mailingAddressStateIdx,
        mailingAddressCity,
        mailingAddressStreet,
        mailingAddressPostalCode
      },
      sourceInput: {
        source: { id: sourceId },
        book: { id: bookId },
        csr: { id: csrId }
      }
    } = this

    const phoneArr = phone.split(',')
    const otherPhoneArr = otherPhone.split(',')
    const salutation : Salutation | null = salutationIndex === -1 ? null : this.salutationKeys[salutationIndex] as Salutation
    try {
      const res = await this.$apollo.mutate({
        mutation: newAccount,
        variables: {
          accountInput: {
            name,
            phone: delNonNumCode(phoneArr[1] || ''),
            otherPhone: delNonNumCode(otherPhoneArr[1] || ''),
            recordTypeId,
            birthday,
            notes,
            salutation,
            firstName,
            middleName,
            lastName,
            billingAddressCountry,
            billingAddressState: states[billingAddressStateIdx] || '',
            billingAddressPostalCode,
            billingAddressCity,
            billingAddressStreet,
            mailingAddressCountry,
            mailingAddressState: states[mailingAddressStateIdx] || '',
            mailingAddressPostalCode,
            mailingAddressCity,
            mailingAddressStreet,
            primaryContactId,
            additionalInfo: this.parseAdditionalInfo(),
            parentAccountId,
            sourceId,
            csrId,
            bookId,
            extensionNumber: phoneArr[2] || '',
            countryCode: phoneArr[0] || '',
            countryCallingCode: phoneArr[3] || '',
            otherExtensionNumber: otherPhoneArr[2] || '',
            otherCountryCode: otherPhoneArr[0] || '',
            otherCountryCallingCode: otherPhoneArr[3] || ''
          }
        }
      })
      this.clearForm()
      this.onGetAccountName(res.data.newAccount.name)
      this.onSuccess(res.data.newAccount.id, 'Create the new account successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      recordTypeInput: { recordType: {
        id: recordTypeId
      } },
      infoInput: {
        name, notes, birthday, salutationIndex, firstName, lastName, middleName,
        parentAccount: {
          id: parentAccountId
        }
      },
      contactInfoInput: {
        primaryContact: {
          id: primaryContactId
        },
        phone,
        billingAddressCountry,
        billingAddressStateIdx,
        billingAddressCity,
        billingAddressStreet,
        billingAddressPostalCode,
        otherPhone,
        mailingAddressCountry,
        mailingAddressStateIdx,
        mailingAddressCity,
        mailingAddressStreet,
        mailingAddressPostalCode
      },
      sourceInput: {
        source: { id: sourceId },
        book: { id: bookId },
        csr: { id: csrId }
      }
    } = this

    const phoneArr = phone.split(',')
    const otherPhoneArr = otherPhone.split(',')
    const salutation : Salutation | null = salutationIndex === -1 ? null : this.salutationKeys[salutationIndex] as Salutation
    try {
      const res = await this.$apollo.mutate({
        mutation: editAccount,
        variables: {
          accountId: +this.account.id,
          accountInput: {
            name,
            birthday,
            phone: delNonNumCode(phoneArr[1] || ''),
            otherPhone: delNonNumCode(otherPhoneArr[1] || ''),
            recordTypeId,
            notes,
            salutation,
            firstName,
            middleName,
            lastName,
            billingAddressCountry,
            billingAddressState: states[billingAddressStateIdx] || '',
            billingAddressPostalCode,
            billingAddressCity,
            billingAddressStreet,
            mailingAddressCountry,
            mailingAddressState: states[mailingAddressStateIdx] || '',
            mailingAddressPostalCode,
            mailingAddressCity,
            mailingAddressStreet,
            primaryContactId,
            additionalInfo: this.parseAdditionalInfo(),
            parentAccountId,
            sourceId,
            csrId,
            bookId,
            extensionNumber: phoneArr[2] || '',
            countryCode: phoneArr[0] || '',
            countryCallingCode: phoneArr[3] || '',
            otherExtensionNumber: otherPhoneArr[2] || '',
            otherCountryCode: otherPhoneArr[0] || '',
            otherCountryCallingCode: otherPhoneArr[3] || ''
          }
        }
      })
      this.clearForm()
      this.onSuccess(res.data.editAccount.id, 'Update account successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  parseAdditionalInfo () {
    return this.ifBusiness
      ? JSON.stringify(this.additionalInfoInput, (key, value) => {
        return value === 0 ? '0' : (value || '')
      })
      : '{}'
  }

  clearForm () {
    this.loading = false
    this.recordTypeInput = {
      recordType: {}
    }
    this.infoInput = {
      name: '',
      birthday: '',
      parentAccount: {},
      notes: '',
      firstName: '',
      lastName: '',
      middleName: '',
      salutationIndex: -1
    }
    this.contactInfoInput = {
      primaryContact: {},
      phone: '',
      billingAddressCountry: '',
      billingAddressStateIdx: -1,
      billingAddressCity: '',
      billingAddressStreet: '',
      billingAddressPostalCode: '',
      otherPhone: '',
      mailingAddressCountry: '',
      mailingAddressStateIdx: -1,
      mailingAddressCity: '',
      mailingAddressStreet: '',
      mailingAddressPostalCode: ''
    }

    this.sourceInput = {
      source: {},
      book: {},
      csr: {}
    }

    this.additionalInput = {}
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (accountId: number, msg = '') {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
    return accountId
  }

  @Emit('getAccountName')
  onGetAccountName (accountName: string) {
    return accountName
  }
}
